module.exports = __webpack_public_path__ + "static/media/medial-nonflexion-up.f55d4e44.png";